import { PaxType } from '@booking/entities/pax-type';
import { TotalPrice } from '@app/entities/price';
import { ProductOption } from '@activities/activities-results/entities/activities-results';
import { AssistanceArrangement, BillingArrangement, Travelers } from '@booking/entities/booking-arrangement';
import { ValidDocuments } from '@app/entities/air-validation.response';

export enum ExtraQuestionDataType {
  OptionList = 'OptionList',
  Text = 'Text',
  Date = 'Date',
  Numeric = 'Numeric',
  TrueFalse = 'TrueFalse',
}

export enum ExtraQuestionType {
  PerActivity = 'PerActivity',
  PerPassenger = 'PerPassenger',
}

export interface ActivityFareBookParamsVM {
  FareId: number;
  Quantity: number;
  SelectedDate: string;
  PaxType: PaxType;
}

export type ActivitiesValidatePayload = Readonly<{
  SearchId: string;
  OptionId: number;
  Products: ActivityFareBookParamsVM[];
  SessionToken?: string;
}>;

export type ActivitiesValidateResponse = Readonly<{
  ExtraQuestions: ExtraQuestion[];
  ProductReference: string;
  Products: ProductValidate;
  ValidDocuments: ValidDocuments[];
  ValidateAvailableUntil: string;
  ValidateToken: string;
}>;

export type ProductValidate = Readonly<{
  TotalPrice: TotalPrice;
  ProductsDetails: ProductOption[];
}>;

export type ActivitiesBookPayloadVM = Readonly<{
  arrangement: ActivitiesBookingArrangement;
  billing: BillingArrangement;
  assistance: AssistanceArrangement;
}>;

export type ActivitiesBookingArrangement = Readonly<{
  ValidateToken: string;
  TravelItineraryId: number;
  Passengers: Travelers[];
  SessionToken?: string;
  TravelExtraQuestions: ActivitiesBookingExtraQuestion[];
}>;

export type ActivitiesBookingExtraQuestion = Readonly<{
  QuestionCode: string;
  AnswerText: string;
  AnswerOptionListId: string;
}>;

export type ActivitiesBookResponse = Readonly<{
  TotalPrice: TotalPrice;
  TravelItineraryId: number;
}>;

export type ExtraQuestion = Readonly<{
  DataType: ExtraQuestionDataType;
  QuestionCode: string;
  QuestionOptionList?: QuestionOptionList[];
  QuestionText: string;
  QuestionType: ExtraQuestionType;
  TravelerIndex: number;
}>;

export type QuestionOptionList = Readonly<{
  Key: string;
  Value: string;
}>;

export type ExtraInformationVM = Readonly<{
  Index: number;
  Title: string;
  Questions: ExtraQuestionVM[];
  QuestionType: ExtraQuestionType;
}>;

export type ExtraQuestionVM = Readonly<{
  FormKey: string;
}> & ExtraQuestion;
